import React, { Component } from 'react';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { Provider, connect } from 'react-redux';
import saga from '../../sagas/circle/new';
import Module from '../../modules/circle/new';
import CircleNameForm from './circle_name_form';
// import FormPage1 from './form_page_1'; 2025/3/18廃止
// import FormOshikatsuCirclesPage from './form_oshikatsu_circles_page'; 2025/3/18廃止
import FormPage2 from './form_page_2';
import FormPage3 from './form_page_3';

const sagaMiddleware = createSagaMiddleware();
const store = createStore(Module.reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(saga);

export default class CircleNew extends Component {
  render() {
    return (
      <Provider store={store}>
        <Root
          servicesCategories={this.props.servicesCategories}
          countriesPrefs={this.props.countriesPrefs}
          isDisableCreateCircle={this.props.isDisableCreateCircle}
          guideline={this.props.guideline}
          isApp={this.props.isApp}
          talkroomId={this.props.talkroomId}
          companyId={this.props.companyId}
          type={this.props.type}
        />
      </Provider>
    );
  }
}

class TmpRoot extends Component {
  constructor(props) {
    super(props);
    this.state = { currentPage: this.props.companyId ? '2' : '0'};
    this.onChangeGenreKeyword = this.onChangeGenreKeyword.bind(this);
    this.onChangeMemberEventCreateEnable =
      this.onChangeMemberEventCreateEnable.bind(this);
  }
  /**
   * コンポーネントマウント時の処理
   */
  UNSAFE_componentWillMount() {
    this.props.initialSet(
      this.props.servicesCategories,
      this.props.countriesPrefs,
      this.props.isDisableCreateCircle
    );
  }

  /**
   * 表示ページが変更された時の処理
   * @param {*} e
   */
  onChangeGenreKeyword(e) {
    this.props.changeGenreKeyword(e.target.value);
  }

  onChangeMemberEventCreateEnable(e) {
    this.props.changeMemberEventCreateEnable(e.target.value);
  }

  render() {
    let page;
    const { type } = this.props;
    if (this.props.pageNum == '2') {
      page = <FormPage2 key={2} isApp={this.props.isApp} type={type} />;
    } else if (this.props.pageNum == '3') {
      page = (
        <FormPage3
          key={3}
          isApp={this.props.isApp}
          talkroomId={this.props.talkroomId}
          companyId={this.props.companyId}
          type={type}
        />
      );
    } else {
      page = (
        <CircleNameForm
          key={0}
          guideline={this.props.guideline}
          isApp={this.props.isApp}
          companyId={this.props.companyId}
          type={type}
        />
      );
    }
    return <div>{page}</div>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  ...state,
  servicesCategories: ownProps.servicesCategories,
  countriesPrefs: ownProps.countriesPrefs,
  isDisableCreateCircle: ownProps.isDisableCreateCircle,
  guideline: ownProps.guideline,
  isApp: ownProps.isApp,
  talkroomId: ownProps.talkroomId,
  type: ownProps.type,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initialSet: (servicesCategories, countriesPrefs, isDisableCreateCircle) => {
      dispatch(
        Module.actions.initialSet({
          servicesCategories,
          countriesPrefs,
          isDisableCreateCircle,
        })
      );
    },
  };
};

const Root = connect(mapStateToProps, mapDispatchToProps)(TmpRoot);
